import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, ref, nextTick } from 'vue';

//components
import ExpandableContent from '../expandable-content/expandable-content.vue';
import TextField from '../text-field/text-field.vue';
import Button from '../button/button.vue';
import IconTickCircle from '@white-label-icon/icon-tick-circle';
import IconCloseCircle from '@white-label-icon/icon-close-circle';

//helpers
import { format, DATE_TIME_FORMATS } from '@white-label-helper/date-utilities';

interface Traveller {
  country_of_residence: string;
  date_of_birth: string;
  firstName: string;
  lastName: string;
}

interface ExpandableContentInstance {
  setExpanded: (value: boolean) => void;
}

interface Props {
  travellers?: Traveller[];
  validation?: any;
  validationMessages?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'payment-page-additional-travellers',
  props: {
    travellers: { default: () => [] },
    validation: { default: () => ({ $each: [] }) },
    validationMessages: { default: () => ({}) }
  },
  setup(__props: any, { expose }) {

const props = __props as { travellers: Traveller[], validation: any, validationMessages: any };

const instance = getCurrentInstance();
const i18n = instance?.proxy.$i18n;



const expandableRefs = ref<{ [key: string]: ExpandableContentInstance }>({});

const setExpandableRef = (index: number) => (el: ExpandableContentInstance | null) => {
  if (el) {
    expandableRefs.value[`expandable-${index}`] = el;
  }
};

const getDateOfBirth = (dob: string): string => {
  const dateFormat = i18n?.locale === 'en-US'
    ? DATE_TIME_FORMATS.month_day_full_year_slash_spaced
    : DATE_TIME_FORMATS.day_month_full_year_slash_spaced;
  return format(new Date(dob), dateFormat);
};

const validateTraveller = async (index: number) => {
  const currentTravellerValidation = props.validation.$each[index];
  currentTravellerValidation.$touch();

  if (currentTravellerValidation.$invalid) {
    return;
  }

  const currentRef = expandableRefs.value[`expandable-${index}`];
  if (currentRef && currentRef.setExpanded) {
    currentRef.setExpanded(false);
  }

  await nextTick();

  //expands next traveller if exists
  const nextIndex = index + 1;
  if (nextIndex < props.travellers.length) {
    const nextRef = expandableRefs.value[`expandable-${nextIndex}`];
    if (nextRef && nextRef.setExpanded) {
      nextRef.setExpanded(true);
    }
  }
};

//expands all travellers that did not pass the validation
//it is triggered on payment form
const expandInvalidTravellers = () => {
  for (let i = 0; i < props.travellers.length; i++) {
    const travellerValidation = props.validation.$each[i];

    if (travellerValidation && travellerValidation.$invalid) {
      const ref = expandableRefs.value[`expandable-${i}`];
      if (ref && ref.setExpanded) {
        ref.setExpanded(true);
      }
    }
  }
};

expose({
  expandInvalidTravellers,
  expandableRefs,
});


return { __sfc: true,instance, i18n, props, expandableRefs, setExpandableRef, getDateOfBirth, validateTraveller, expandInvalidTravellers, ExpandableContent, TextField, Button, IconTickCircle, IconCloseCircle }
}

})